import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { ReferralProvider } from "@/context/ReferralContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Redeem from "@/pages/Redeem";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import FamilyBundle from "@/pages/FamilyBundle";
import BusinessLanding from "@/pages/BusinessLanding";
import StudentDiscount from "@/pages/StudentDiscount";
import StudentConfirm from "@/pages/StudentConfirm";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // OAuth callback returns with #session_id=... — process first before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/redeem" element={<Redeem />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/bundle/family" element={<FamilyBundle />} />
      <Route path="/business" element={<BusinessLanding />} />
      <Route path="/student" element={<StudentDiscount />} />
      <Route path="/student/confirm" element={<StudentConfirm />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <ReferralProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster theme="dark" richColors position="top-right" />
          </AuthProvider>
        </ReferralProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
